module.exports = __webpack_public_path__ + "static/media/Developmental_Neurobiology_Special_Issue_Cover_Image_May_2019_Published.6eb522fd.png";